<template>
  <v-flex xs12>
    <v-select
      :value="currentValue"
      @input="onInput"
      :items="timeList"
      :label="label"
      :disabled="disabled"
      :placeholder="placeholder"
    ></v-select>
  </v-flex>
</template>

<script>

  import moment from 'moment'

  const TIME_INTERVAL = [ 5, 10, 15, 20, 30, 60, 120, 180, 240 ]
  const TIME_FORMAT = 'HH:mm'

  /**
   *
   *
   */
  export default {

    name: 'TimePicker',

    /**
     * Внешние данные компонента.
     *
     */
    props: {

      // Необходимо для инициализации значения по умолчанию
      value: {

      },

      // Режим редактирования.
      editable: {
        type: Boolean,
        required: false,
        default: false
      },

      // Шаг времени в списке.
      interval: {
        type: Number,
        required: false,
        default: 30,
        validator: function ( value ) {
          return TIME_INTERVAL.indexOf( value ) !== -1
        }
      },

      // Название поля.
      label: {
        type: String,
        required: false,
        default: ''
      },

      //
      placeholder: {
        type: String,
        required: false,
        default: ''
      },

      //
      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    /**
     * Данные компонента.
     *
     */
    data() {

      return {

        mask: '##:##',

        currentValue: null
      }
    },

    /**
     * После создания компонента.
     *
     */
    created() {

      this.init()
    },

    /**
     * Отслеживание изменения свойств компонента.
     *
     */
    watch: {

      /**
       * Начальное значение времени.
       *
       */
      value: {

        handler( value ) {
          this.currentValue = value ? this.roundTime( value ) : null
          this.onInput( this.currentValue )
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      },
    },

    /**
     *
     *
     */
    computed: {

      /**
       * Формирование списка времени.
       *
       * Список формируется с учетом интервала шага.
       *
       */
      timeList() {

        let list = [ '00:00' ]
        let count = ( 24 * 60 ) / this.interval
        let time = moment( '00:00', TIME_FORMAT )

        for( let index = 1; index < count; index++ ) {
          time.add( this.interval, 'minutes' )
          list.push( time.format( TIME_FORMAT ) )
        }

        return list
      }
    },

    /**
     * Методы компонента.
     *
     */
    methods: {

      /**
       * Инициализация компонента.
       *
       */
      init() {

      },

      /**
       *
       *
       * @param value
       */
      onInput( value ) {
        this.$emit( 'input', value )
      },

      /**
       * Округление времени до установленного интервала шага.
       *
       * @param _time
       * @returns {string}
       */
      roundTime( _time ) {

        let step = this.interval
        let time = moment( _time, 'HH:mm' )
        let minutes = time.minutes()

        time.startOf( 'hour' )
        time.add( Math.round( minutes / step ) * step, 'minutes' )

        return time.format( TIME_FORMAT )
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/TimePicker.vue